import { Modal } from "antd"
import PropTypes from "prop-types"
import { useState, useEffect } from "react"
import zoomIcon from "./zoom-icon.svg"
import * as css from "./ZoomRedirectModal.module.css"

function ZoomRedirectModal({ url, closeModal }) {
  const [counter, setCounter] = useState(3)

  useEffect(() => {
    if (counter > 0) {
      setTimeout(() => setCounter(counter - 1), 1000)
    } else {
      closeModal()
      window.location.href = url
    }
  }, [counter])

  return (
    <Modal open footer={null} closable={false} centered width={400}>
      <div className={css.content}>
        <img className={css.icon} src={zoomIcon} alt="Zoom" />
        <p className={css.message}>
          You will now be redirected to Zoom to complete your registration in...
          {counter}
        </p>
      </div>
    </Modal>
  )
}

ZoomRedirectModal.propTypes = {
  url: PropTypes.string,
  closeModal: PropTypes.func,
}

export default ZoomRedirectModal
